// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"921dffb7","455":"bad16732","977":"3bba5e2c"}[chunkId] + ".chunk.js";
};